module.exports = __webpack_public_path__ + "static/media/refresh.47c3225f.svg";